<script>
import { preventDefault } from "svelte/legacy";
import { fade } from "svelte/transition";
import { modalState, hideModal } from "@app/store/modalStore.svelte.js";
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import EventGroup from "@cclib/classes/eventGroup.js";
import mergeTranslation from "@app/lib/mergeTranslation.js";
import LanguageSelect from "@app/components/inputs/LanguageSelect.svelte";
import { toast } from "@zerodevx/svelte-toast";
import * as m from "@app/paraglide/messages.js";

let eventGroupDefaults =
    JSON.parse(localStorage.getItem("cc-event-group-defaults")) || {};
let eventGroupType = "translation",
    displayName = $state(m.translation_merge_default_name()),
    language = $state(eventGroupDefaults.language || "en-US"),
    sourceGroupIndex = $state(0),
    targetGroupIndex = $state(0),
    rtl = $state(eventGroupDefaults.rtl),
    working = false;

function createTranslationGroup() {
    try {
        if (working) {
            return;
        }

        if (!eventGroupState[sourceGroupIndex]) {
            return;
        }

        if (!eventGroupState[targetGroupIndex]) {
            return;
        }

        working = true;

        let evgSource = JSON.parse(
            JSON.stringify(eventGroupState[sourceGroupIndex]),
        );
        let evgTarget = JSON.parse(
            JSON.stringify(eventGroupState[targetGroupIndex]),
        );
        let mergedEvents = mergeTranslation(evgSource, evgTarget);

        eventGroupState.push(
            {...(new EventGroup({
                type: eventGroupType,
                name: displayName,
                language: language,
                linkedGroup: eventGroupState[sourceGroupIndex].id,
                originalFontFamily: eventGroupState[sourceGroupIndex].fontFamily,
                originalRtl: eventGroupState[sourceGroupIndex].rtl ?? false,
                rtl: rtl,
                events: mergedEvents,
            }))}
        );

        projectState.selected = eventGroupState.length - 1;
        eventGroupState[projectState.selected].selected = [0];

        insertHistoryAction({
            name: "merge translation", //action name
            eventGroup: projectState.selected,
            snapshots: [
                {
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState),
                },
            ],
        });

        toast.push(m.translation_merge_success_toast(), {
            classes: ["toast-success"],
        });
    } catch (err) {
        toast.push(m.translation_merge_error_toast({ error: err.message }), {
            classes: ["toast-danger"],
        });
        console.log(err, err.message);
    } finally {
        hideModal();
        working = false;
    }
}
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'translationMerge'
        ? 'show d-block'
        : ''}"
    role="dialog"
    aria-labelledby="mergeEventTitle"
    aria-describedby="mergeEventDesc"
    tabindex="-1"
    id="TranslationMergeEventGroupModal">
    <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
        role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mergeEventTitle">
                    {m.translation_merge_title()}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    id="btnCloseMergeEvent"
                    aria-label={m.close_dialog()}
                    onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <form onsubmit={preventDefault(createTranslationGroup)}>
                    <!-- Name -->
                    <div class="mb-3">
                        <label class="form-label" for="mergeEventDisplayName"
                            ><span class="badge bg-primary">{m.new()}</span> {m.translation_merge_display_name_label()}</label>
                        <input
                            class="form-control"
                            id="mergeEventDisplayName"
                            required
                            placeholder={m.translation_merge_display_name_placeholder()}
                            type="text"
                            bind:value={displayName}
                            aria-required="true" />
                    </div>
                    <!-- Language -->
                    <div class="mb-3">
                        <label class="form-label" for="mergeEventLanguage"
                            >{m.translation_merge_language_label()}</label>
                        <LanguageSelect id="mergeEventLanguage" bind:value={language} />
                    </div>
                    <!-- RTL -->
                    <div class="form-check form-switch mb-2">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            id="mergeEventRtl"
                            bind:checked={rtl}
                            aria-checked={rtl} />
                        <label class="form-check-label" for="mergeEventRtl"
                            >{m.right_to_left()}</label>
                    </div>
                    <!-- Source Group -->
                    <div class="mb-3">
                        <label class="form-label" for="Source group"
                            >{m.translation_merge_source_group_label()} <i
                                class="bi bi-info-circle"
                                title={m.translation_merge_source_group_help()}
                            ></i
                            ></label>
                        <select
                            class="form-select"
                            bind:value={sourceGroupIndex}>
                            {#each eventGroupState as eventGroup, index (index)}
                                <option value={index}>{eventGroup.name}</option>
                            {/each}
                        </select>
                    </div>
                    <!-- Target Group -->
                    <div class="mb-3">
                        <label class="form-label" for="Target group"
                            >{m.translation_merge_target_group_label()} <i
                                class="bi bi-info-circle"
                                title={m.translation_merge_target_group_help()}
                            ></i
                            ></label>
                        <select
                            class="form-select"
                            bind:value={targetGroupIndex}>
                            {#each eventGroupState as eventGroup, index (index)}
                                <option value={index}>{eventGroup.name}</option>
                            {/each}
                        </select>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button
                    class="btn btn-primary"
                    type="button"
                    id="btnTranslationMerge"
                    onclick={() => createTranslationGroup()}
                    >{m.translation_merge_create_button()}</button>
            </div>
        </div>
    </div>
</div>
